import React, {useCallback, useState} from 'react'
import {StripeProvider} from 'react-stripe-elements'
import StripeScriptLoader from 'react-stripe-script-loader'
import {CardCvcElement, CardExpiryElement, CardNumberElement, Elements} from '@stripe/react-stripe-js'
import {loadStripe} from '@stripe/stripe-js'
import {v4 as uuid} from 'uuid';

import {ordersService} from 'services'
import BButton from 'components/Form/Fields/BButton'
import priceParser from 'utils/priceParser'
import SideSummary from 'modules/Checkout/SideSummary'
import useUserContext from 'components/User/useUserContext'

const tmpPrice = 4242.42
const tmpCartUuid = 'f842f0b5-75a8-418c-a0a7-1e6e0ff469a0'

const apiKey = process.env.NODE_ENV === 'production' ? 'pk_live_EaRrLqzKii5KcOTO2yN4T5HB009pT8KQ6v' : 'pk_test_TTTsDgPcJjaBcZIJ8mxnVZ0C00xYztYJVQ'
const stripePromise = loadStripe(apiKey)

const options = {
  style: {
    base: {
      iconColor: '#c4f0ff',
      fontWeight: 500,
      fontSize: '18px',
      fontSmoothing: 'antialiased',
      ':-webkit-autofill': {color: '#fce883'},
      '::placeholder': {color: '#899696'},
    },
    invalid: {
      iconColor: '#ffc7ee',
      color: '#ab0011',
    },
  },
}

const PaymentMethod = ({t, back, billingInfo}) => {
  const {user, delivery} = useUserContext()

  const [data, setData] = useState({cardNumberDone: false, expDateDone: false, cvcDone: false})

  const preparePurchase = useCallback(() => {
    const rqBody = {
      groupOrderUuid: uuid(),
      useBuildiroPoints: false,
    }
    let request

    if (user) {
      rqBody.deliveryAddressUuid = delivery.uuid
      // rqBody.??? = billingInfo TODO
      request = () => ordersService.userPrepareOrderGroupPayment(tmpCartUuid, rqBody)
    } else {
      const guestUser = {}
      guestUser.customerProfile = {
        deliveryAddresses: [{...delivery}],
        billingInfo,
      }
      rqBody.guestUser = guestUser
      request = () => ordersService.guestPrepareOrderGroupPayment(tmpCartUuid, rqBody)
    }

    console.log(rqBody)

    /*
    requestHandler(request, 'json')
      .then(r => {
        console.log(r)
      })
     */
  }, [billingInfo, delivery, user])

  const handleSubmit = useCallback(e => {
    e.preventDefault()
  }, [])

  return (
    <>
    {/*
    <StripeScriptLoader
      uniqueId='myUniqueId'
      script='https://js.stripe.com/v3/'>
      <StripeProvider apiKey={apiKey}>
        <Elements stripe={stripePromise}>
          <form onSubmit={handleSubmit} className='stripeForm'>
            <div>
              <h6>{t('Payment information')}</h6>

              <label>
                {t('CARD')}
              </label>

              <CardNumberElement
                className='cardInput'
                options={options}
                onReady={() => {
                  console.log('CardNumberElement [ready]')
                }}
                onChange={event => {
                  console.log('CardNumberElement [change]', event)
                  setData(d => ({...d, cardNumberDone: event.complete}))
                }}
                onBlur={() => {
                  console.log('CardNumberElement [blur]')
                }}
                onFocus={() => {
                  console.log('CardNumberElement [focus]')
                }}
              />

              <div className='stripeForm-ExpCVC'>
                <div>
                  <label>{t('EXP. DATE')}</label>

                  <CardExpiryElement
                    className='cardInput'
                    options={options}
                    onReady={() => {
                      console.log('CardNumberElement [ready]')
                    }}
                    onChange={event => {
                      console.log('CardNumberElement [change]', event)
                      setData(d => ({...d, expDateDone: event.complete}))
                    }}
                    onBlur={() => {
                      console.log('CardNumberElement [blur]')
                    }}
                    onFocus={() => {
                      console.log('CardNumberElement [focus]')
                    }}
                  />
                </div>

                <div>
                  <label>CVC</label>

                  <CardCvcElement
                    className='cardInput'
                    options={options}
                    onReady={() => {
                      console.log('CardNumberElement [ready]')
                    }}
                    onChange={event => {
                      console.log('CardNumberElement [change]', event)
                      setData(d => ({...d, cvcDone: event.complete}))
                    }}
                    onBlur={() => {
                      console.log('CardNumberElement [blur]')
                    }}
                    onFocus={() => {
                      console.log('CardNumberElement [focus]')
                    }}
                  />
                </div>
              </div>
            </div>

            <BButton ghost onClick={back}>{t('back to delivery & billing info')}</BButton>

            <BButton
              yellow
              disabled={!(data.cardNumberDone && data.expDateDone && data.cvcDone)}
            >
              {t('Pay now {{price}}', {price: priceParser(tmpPrice)})}
            </BButton>
          </form>
        </Elements>
      </StripeProvider>
    </StripeScriptLoader>
    */}

      <button onClick={preparePurchase}>test to console.log</button>
    </>
  )
}

const Checkout3 = ({t, back, billingInfo}) => (
  <div id='checkout3' className='checkout-basicLayout'>
    <h1>{t('Payment')}</h1>

    <div>
      <PaymentMethod t={t} back={back} billingInfo={billingInfo}/>

      <div>
        <div>
          <SideSummary t={t}/>
        </div>
      </div>
    </div>
  </div>
)

export default Checkout3
